export const MainWrapper = 'flex w-full flex-col'

export const OrderListWrapper = 'md:pb-6 mb-4'

export const DataAndAddressWrapper =
  'flex w-full flex-col py-8 md:flex-row md:py-12 border-machine2-75 border-t '

export const LeftItemWrapper = 'pb-6 md:pb-0 md:pr-8'

export const PaymentsAndPrivacyWrapper =
  'border-machine2-75 flex w-full flex-col border-t py-6 md:flex-row md:py-12'

export const MachinesWrapper = 'py-4 md:py-10 border-machine2-75 border-t'
